// removed by extract-text-webpack-plugin
module.exports = {"victual":"Victual__victual__3GYHH","name":"Victual__name__1y4QT","desc":"Victual__desc__3e9nd","price":"Victual__price__3-ajt","order":"Victual__order__3OSsZ","orderNumber":"Victual__orderNumber__323ve","dec":"Victual__dec__1wJaU","inc":"Victual__inc__1lRmV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Menu/Victual/Victual.css
// module id = 102
// module chunks = 0